"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ConnectivityStatusConnected = function ConnectivityStatusConnected() {
  var localize = (0, _useLocalizer.default)();
  return _react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', localize('CONNECTIVITY_STATUS_ALT_CONNECTED'))
  });
};

var _default = ConnectivityStatusConnected;
exports.default = _default;